
import { defineComponent, PropType } from 'vue'
import { iDocument, iMetaSource, iTableSmall } from '@/modules/documentExecution/documentDetails/DocumentDetails'
import { AxiosResponse } from 'axios'
import { filterDefault } from '@/helpers/commons/filterHelper'
import mainDescriptor from '@/modules/documentExecution/documentDetails/DocumentDetailsDescriptor.json'
import Dropdown from 'primevue/dropdown'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InlineMessage from 'primevue/inlinemessage'

export default defineComponent({
    name: 'data-lineage',
    components: { Dropdown, DataTable, Column, InlineMessage },
    props: { selectedDocument: { type: Object as PropType<iDocument>, required: true }, metaSourceResource: { type: Array as PropType<iMetaSource[]>, required: true }, savedTables: { type: Array as PropType<iTableSmall[]>, required: true } },
    emits: [],
    data() {
        return {
            mainDescriptor,
            dataSource: {} as iMetaSource,
            tablesList: [] as iTableSmall[],
            selectedTables: [] as iTableSmall[],
            loading: false,
            filters: { global: [filterDefault] } as Object,
            globalFilterFields: ['name']
        }
    },
    created() {},

    methods: {
        async getTablesBySourceID() {
            this.loading = true
            this.$http
                .get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `2.0/metaSourceResource/${this.dataSource.sourceId}/metatables`)
                .then((response: AxiosResponse<any>) => {
                    this.tablesList = response.data as iTableSmall[]
                    this.setCheckedTables()
                })
                .finally(() => (this.loading = false))
        },
        setCheckedTables() {
            for (var i = 0; i < this.tablesList.length; i++) {
                for (var j = 0; j < this.savedTables.length; j++) {
                    if (this.tablesList[i].tableId == this.savedTables[j].tableId) {
                        this.selectedTables.push(this.tablesList[i])
                    }
                }
            }
        },
        peristTable(event) {
            this.$http
                .post(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `2.0/metaDocumetRelationResource/${this.selectedDocument.id}`, event.data, {
                    headers: { 'X-Disable-Errors': 'true' }
                })
                .then(() => this.$store.commit('setInfo', { title: this.$t('common.save'), msg: this.$t('documentExecution.documentDetails.dataLineage.persistOk') }))
                .catch(() => this.$store.commit('setError', { title: this.$t('common.toast.errorTitle'), msg: this.$t('documentExecution.documentDetails.dataLineage.persistError') }))
        },
        deleteTable(event) {
            this.$http
                .delete(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `2.0/metaDocumetRelationResource/${this.selectedDocument.id}/${event.data.tableId}`, {
                    headers: { 'X-Disable-Errors': 'true' }
                })
                .then(() => this.$store.commit('setInfo', { title: this.$t('common.save'), msg: this.$t('documentExecution.documentDetails.dataLineage.deleteOk') }))
                .catch(() => this.$store.commit('setError', { title: this.$t('common.toast.errorTitle'), msg: this.$t('documentExecution.documentDetails.dataLineage.deleteError') }))
        }
    }
})
